import { t } from 'i18next';

import { Box, Stack } from '@mui/system';
import { Card, Paper, Button, useTheme, CardHeader, Typography, CardContent } from '@mui/material';

import { useBoolean } from 'src/hooks/use-boolean';
import { useAuthContext } from 'src/hooks/auth/use-auth-context';

import Iconify from 'src/components/iconify';

import DataExportDialog from 'src/sections/export/data-export-dialog';

const ResourceExportCard = () => {

  const { organization } = useAuthContext();

  const resourceExporterControl = useBoolean();

  const theme = useTheme();

  return (
    <Box>
      <Card
        sx={{
          width: '100%',
          position: 'relative',
          boxShadow: 0
        }}
      >
        <CardHeader
          avatar={
            <Iconify
              icon="eva:download-outline"
              sx={{
                width: 30,
                height: 30,
                color: theme.palette.primary.main,
              }}
            />
          }
          title={
            <Typography variant="h6">
              {t('admin-organization.settings.resource_export.title')}
            </Typography>
          }
        />

        <CardContent>
          <Paper sx={{ mb: 3, px: 2 }}>
            <Stack direction="row" spacing={2} sx={{ py: 1 }} justifyContent="space-between" alignItems="center">
              <Stack direction="column" sx={{ mb: 2 }} >
                <Typography variant="h6">
                  {t('admin-organization.settings.resource_export.action_title')}
                </Typography>
                <Typography variant="caption">
                  {t('admin-organization.settings.resource_export.action_subtitle')}
                </Typography>
              </Stack>

              <Button
                startIcon={<Iconify icon="eva:download-outline" />}
                variant="outlined"
                onClick={resourceExporterControl.onTrue}
              >
                {t('common.export')}
              </Button>
            </Stack>
          </Paper>

        </CardContent>
      </Card>

      <DataExportDialog open={resourceExporterControl.value} onClose={resourceExporterControl.onFalse} organizationId={organization.id} />

    </Box>
  );
}

export default ResourceExportCard;
